module.exports = __webpack_public_path__ + "img/embedded.cdd6f61f.png";